'use client';

import { ReactNode } from 'react';

import type { Icon } from '@personly/libs-types';
import { Toggle } from '@personly/libs-widgets';

import { useLegalTerms } from '@/providers/legalTerms';

interface Props {
  children: ReactNode;
  toggleIcons: Icon[];
}

const LegalTermsToggle = ({ children, toggleIcons }: Props) => {
  const {
    setTermsOfServiceAccepted,
    termsOfServiceAccepted,
    setPrivacyPolicyAccepted,
    privacyPolicyAccepted,
  } = useLegalTerms();

  const onClick = () => {
    setPrivacyPolicyAccepted(!privacyPolicyAccepted);
    setTermsOfServiceAccepted(!termsOfServiceAccepted);
  };

  const selectedState = privacyPolicyAccepted && termsOfServiceAccepted;

  const toggleIcon = toggleIcons.find(
    (icon) => icon.flags.isSelected === selectedState
  );

  return (
    <Toggle onClick={onClick} icon={toggleIcon}>
      {children}
    </Toggle>
  );
};

export default LegalTermsToggle;
